import React from 'react';
import CardboardCutout from '../brand/CardboardCutout';
import { BADGE_FOR_MOTION } from '../brand/BearriBadge';
import type { BearriMotionName } from '../brand/motionAssets';
import '../brand/brandScenes.css';

const SIZES = { sm: 52, md: 96, lg: 144 };

/**
 * A loading mark. With `art={false}` it is the track alone — the ink is not
 * there yet — because under a page's hero pin a second bear is one too many;
 * the pin does the working. Card- and dialog-level loaders may keep the bear.
 *
 * The bear is the NEW pin family (the cut-out the page heroes use), rocking on its
 * foot while it waits. It used to play the old "thinking" clip — a pink bust from an
 * earlier drawing — so a loading state flashed a different character than the page.
 * `motion` still names what kind of wait this is; it picks the matching pin.
 */
export function NectarLoader({ size = 'md', label = 'Loading', className = '', motion = 'thinking', art = true }: {
  size?: keyof typeof SIZES;
  label?: string;
  className?: string;
  motion?: BearriMotionName;
  art?: boolean;
}) {
  return (
    <div role="status" className={`br-loader ${className}`} style={{ width:SIZES[size], height: art ? SIZES[size] : 10 }}>
      {art && <span className="br-loader__pin" aria-hidden="true"><CardboardCutout name={BADGE_FOR_MOTION[motion] || 'research'} withEdges={false} /></span>}
      <span className="br-loader__track" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}

export default NectarLoader;
